/** Main site of OrthoHouse, the parent shop that runs healthyshoes.com.cy. */
export const ORTHOHOUSE_URL = 'https://orthohouse.com.cy/';

/** The parent-site links are shop chrome; keep them out of internal tools. */
export function showsOrthoHouseLinks(pathname: string): boolean {
	return !/^\/(?:(?:el|ru|he)\/)?admin(?:\/|$)/.test(pathname);
}
